import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageCircle } from 'lucide-react';
import SEO from '../components/SEO';
import { getFullUrl } from '../utils/url';
import { mockData } from '../data/mock';
import { HeroSection } from '../components/home/HeroSection';
import { SectorsMarquee } from '../components/home/SectorsMarquee';
import { ServicesBento } from '../components/home/ServicesBento';
import { StatsSection } from '../components/home/StatsSection';
import { PhilosophySection } from '../components/home/PhilosophySection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { PennylaneSection } from '../components/home/PennylaneSection';
import { ActualitesSection } from '../components/home/ActualitesSection';
import { FinalCta } from '../components/home/FinalCta';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Home = () => {
  const [temoignages, setTemoignages] = useState([]);
  const [loadingTemoignages, setLoadingTemoignages] = useState(true);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tRes, aRes] = await Promise.all([
          axios.get(`${API}/temoignages`),
          axios.get(`${API}/articles?limit=3`),
        ]);
        setTemoignages(tRes.data);
        setArticles(aRes.data);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Erreur chargement données accueil:', err);
        }
        setTemoignages(mockData.temoignages);
      } finally {
        setLoadingTemoignages(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <SEO
        title="MMD CONSEIL - Expert-Comptable à Lyon | Le conseil au-delà des chiffres"
        description="Cabinet d'expertise comptable MMD CONSEIL à Lyon et Rillieux-la-Pape. Makhan DIALLO, expert-comptable diplômé DEC : comptabilité, fiscalité, paie, stratégie de rémunération et conseil sur-mesure pour dirigeants."
        keywords="expert-comptable Lyon, cabinet comptable Rillieux-la-Pape, stratégie de rémunération, conseil entreprise Lyon, Makhan DIALLO, MMD CONSEIL"
        url={getFullUrl('/')}
      />

      <HeroSection />
      <SectorsMarquee />
      <ServicesBento />
      <StatsSection />
      <PhilosophySection />
      <TestimonialsSection temoignages={temoignages} loading={loadingTemoignages} />
      <PennylaneSection />
      <ActualitesSection articles={articles} />
      <FinalCta />

      {/* WhatsApp flottant (desktop uniquement — sur mobile, barre d'action en bas) */}
      <a
        href={`https://wa.me/${mockData.cabinet.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn hidden md:flex items-center justify-center"
        aria-label="Contactez-nous sur WhatsApp"
        data-testid="whatsapp-float"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
};

export default Home;
